import { EventType } from "./ActiveEvents";
import { BatchImpactAssessment } from "./BatchImpactAssessment";
import { EventAttachment } from "./EventAttachment";
import { ImpactedDelivery } from "./ImpactedDelivery";
import { ImpactedHandlingUnit } from "./ImpactedHandlingUnit";
import { ImpactedOrder } from "./ImpactedOrder";

export interface EventDetails {
    eventId: number;
    isClosed: boolean;
    eventType: EventType;
    eventCreatedAt: Date;
    eventClosedAt: Date;
    minTemperature: number;
    maxTemperature: number;
    durationInHours: number;
    priority: string;
    impactedDeliveries: ImpactedDelivery[];
    impactedOrders: ImpactedOrder[];
    impactedHandlingUnits: ImpactedHandlingUnit[];
    impactedBatches: BatchImpactAssessment[];
    reviewerUserId: string;
    qaUserId: string;
    eventStatusId: EventStatus;
    eventAttachments: EventAttachment[];
    dueDate: Date;
}

export enum EventStatus {
    New = 0,
    PendingReview = 1,
    PendingApproval = 2,
    Closed = 3,
    ReOpened = 4,
}
